import axios from 'axios';

export default axios.create({
  baseURL: '/api',
});



// WEBPACK FOOTER //
// ./src/utils/service.js